import React from 'react';

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export default function GeneralSkeleton() {
  return (
    <>
      <Box
        component="div"
        data-testid="json-viewer-loading-skeleton"
        display="flex"
      >
        <StyledSkeletonHeader
          animation="pulse"
          height="68px"
          sx={{ margin: '0 0 1.25rem 0' }}
          variant="text"
          width="100vw"
        />
      </Box>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          margin: '0 0 1.25rem 0',
        }}
      >
        <Stack direction="column" spacing={1}>
          <StyledSkeleton
            animation="pulse"
            variant="rectangular"
            width="45vw"
          />
          <StyledSkeleton animation="pulse" variant="text" width="20vw" />
        </Stack>
        <StyledSkeleton animation="pulse" variant="text" width="135px" />
        <StyledSkeleton animation="pulse" variant="text" width="135px" />
        <StyledSkeleton animation="pulse" variant="text" width="135px" />
        <StyledSkeleton animation="pulse" variant="text" width="135px" />
      </Box>
    </>
  );
}
const StyledSkeletonHeader = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.palette.grey[300],
  borderRadius: '6px',
  marginRight: '12px',
}));
const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  borderRadius: '6px',
  marginRight: '12px',
}));
